export var LoanRenewalScenario;
(function (LoanRenewalScenario) {
    LoanRenewalScenario["FIRST_7_DAYS"] = "FIRST_7_DAYS";
    LoanRenewalScenario["FROM_7_TO_30_DAYS"] = "FROM_7_TO_30_DAYS";
    LoanRenewalScenario["AFTER_30_DAYS"] = "AFTER_30_DAYS";
    LoanRenewalScenario["OUTSTANDING_EXPIRED"] = "OUTSTANDING_EXPIRED";
    LoanRenewalScenario["LOAN_EXPIRED_WITHOUT_OUTSTANDING"] = "LOAN_EXPIRED_WITHOUT_OUTSTANDING";
})(LoanRenewalScenario || (LoanRenewalScenario = {}));
